import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

import TabMenuItem from './TabMenuItem';

class TabComponent extends React.PureComponent {
  static propTypes = {
    panes: PropTypes.array.isRequired,
    children: PropTypes.node.isRequired,
    visiblePaneIndex: PropTypes.number.isRequired,
    setVisiblePaneIndex: PropTypes.func.isRequired
  }

  render () {
    const { visiblePaneIndex } = this.props;

    return (
      <div className="main-tabs width-full">
        {map(this.props.panes, (pane, index) =>
        /* eslint-disable react/jsx-handler-names */

          <TabMenuItem
            id={index} key={index}
            onClick={pane.onMenuItemClick}
            active={visiblePaneIndex === index}
            setVisiblePaneIndex={this.props.setVisiblePaneIndex}
          >

            {pane.renderMenuItem()}
          </TabMenuItem>
        )}

        {this.props.children}
      </div>
    );
  }
}

export default TabComponent;
